import { render, staticRenderFns } from "./sql.vue?vue&type=template&id=321324b5&scoped=true&"
import script from "./sql.vue?vue&type=script&lang=js&"
export * from "./sql.vue?vue&type=script&lang=js&"
import style0 from "./sql.vue?vue&type=style&index=0&id=321324b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321324b5",
  null
  
)

export default component.exports